import React, { useContext } from "react";
import styled from "styled-components";
import { APIContext } from "../../contexts/APIContext";
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green
      ? "#0adb93"
      : props.red
      ? "#db0a41"
      : props.layout === "middle"
      ? "#202731"
      : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 50px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
function Lineup({ component, game, previewGraphic, homeManager, awayManager }) {
  return (
    <GraphicButton
      onClick={async () => {
        let team =
          component?.data?.options?.team === "home"
            ? game.home_team
            : game.away_team;
        let squad =
          component?.data?.options?.team === "home"
            ? game.lineup?.home
            : game.lineup?.away;
        let manager =
          component?.data?.options?.team === "home" ? homeManager : awayManager;
        let formation =
          component?.data?.options?.team === "home"
            ? game.home_formation
            : game.away_formation;
        previewGraphic("Lineup", {
          game: game,
          team: team,
          squads: squad,
          formation: formation,
          manager: manager,
        });
      }}
    >
      {component?.data?.label}
    </GraphicButton>
  );
}

export default Lineup;
